import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

const marker = $('#marker');

if( $('.mapbox-wrapper') ) {
    if ( marker.attr( 'data-lng' ) ) {
        var markerPosition = new mapboxgl.LngLat( marker.attr( 'data-lng' ), marker.attr( 'data-lat' ) );
        mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsN3Fha3ZmYjAzazEzb21xa3hzanBvcjcifQ.S1idm0gWrmkdyOUD493y5Q';

        var map = new mapboxgl.Map({
            container: 'mapboxWrapper',
            style: 'mapbox://styles/blackdesk/cl7qbtpp9003h14mmautf84dg',
            attributionControl: false,
            center: markerPosition,
            maxZoom: 18,
            zoom: 14,
        });

        var el = document.createElement( 'div' );
        el.className = 'marker-custom';
        el.style.backgroundImage = 'url(/wp-content/themes/lagerweijfonk/public/images/contact-marker.svg)';

        new mapboxgl.Marker(el)
        .setLngLat( markerPosition )
        .addTo( map );

        map.on( 'load', function() {
            map.resize();
        });
    }
}
